import {
  ChangeDetectionStrategy,
  Component,
  NgModule,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareModule } from 'ngx-sharebuttons';
import { TranslocoModule } from '@ngneat/transloco';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'i2l-ui-social-share',
  template: `
    <div>
      <ng-container *transloco="let t">
        <span
          class="filter-group__label"
          [innerHTML]="t('actions.share')"
        ></span>
      </ng-container>
    </div>
    <div class="b-buttons">
      <button shareButton="facebook">
        <mat-icon svgIcon="icon-facebook"></mat-icon>
      </button>
      <button shareButton="linkedin">
        <mat-icon svgIcon="icon-linkedin"></mat-icon>
      </button>
      <button shareButton="twitter">
        <mat-icon svgIcon="icon-twitter"></mat-icon>
      </button>
    </div>
  `,
  styleUrls: ['./social-share.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialShareComponent {}

@NgModule({
  imports: [CommonModule, ShareModule, TranslocoModule, MatIconModule],
  declarations: [SocialShareComponent],
  exports: [SocialShareComponent],
})
export class SocialShareComponentModule {}
